const API_URL =
    document.domain === 'localhost'
    ? "https://integradorbaoba.masterdaweb.net"
    : "https://integradorbaoba.masterdaweb.net";

const Apis = {
  //Authentication api
  GetUserLogin: `${API_URL}/api/auth/rootLogin`,
  GetUserRegsiter: `${API_URL}/api/auth/register`,
  GetAllUserList: `${API_URL}/api/auth/user/getAllUserList`,
  GetUserUpdate: `${API_URL}/api/auth/user/update`,
  GetDeleteUserList: `${API_URL}/api/auth/user/delete`,

  //filiais api
  FilialRegister: `${API_URL}/api/filiais/register`,
  FilialList: `${API_URL}/api/filiais/getAllFiliais`,
  getFilialid: `${API_URL}/api/filiais/getFilialid`,
  FilialUpdate: `${API_URL}/api/filiais/update`,
  FilialDelete: `${API_URL}/api/filiais/delete`,

  LogProcessosRegister: `${API_URL}/api/log_processos/register`,
  LogProcessosList: `${API_URL}/api/log_processos/getlog_processos`,

  AddCTRL: `${API_URL}/api/log_processos/addCTRL`,
  getCTRL: `${API_URL}/api/log_processos/getCTRL`,

  addEntradaOT: `${API_URL}/api/log_processos/addEntradaOT`,
  getEntradaOT: `${API_URL}/api/log_processos/getEntradaOT`,
  EntradaOTUpdate: `${API_URL}/api/log_processos/EntradaOTUpdate`,

  CTRLUpdate: `${API_URL}/api/log_processos/CTRLUpdate`,
  deleteCTRL: `${API_URL}/api/log_processos/deleteCTRL`,

  getCTRLSaida: `${API_URL}/api/log_processos/getCTRLSaida`,
  CTRLUpdateSaida: `${API_URL}/api/log_processos/CTRLUpdateSaida`,


  //Produtos api
  ProdutosRegister: `${API_URL}/api/produtos/register`,
  getallprodutos: `${API_URL}/api/produtos/getallprodutos`,
  getallprodutosid: `${API_URL}/api/produtos/getallprodutosid`,
  

};
export { API_URL, Apis };
